
import { Vue, Component, Watch } from "vue-property-decorator"
import PlanningFilterDialog from "@/components/dialogs/PlanningFilterDialog.vue"
import { Require } from "@coredination/components"
import moment from "moment"
import { Route } from "vue-router"

@Component({
    components: {
        Require,
        MyWorkHistoryList: () => import("@/components/misc/MyWorkHistoryList.vue"),
        PlanningFilterDialog,
    },
    beforeRouteLeave(to: Route, from: Route, next: any) {
        var scrollTop = this.$el.querySelector(".items-list")?.scrollTop?.toFixed(2)
        if (scrollTop) sessionStorage.setItem("historyScrollTop", "" + scrollTop)
        next()
    },
})
export default class HistoryView extends Vue {
    selectedTimePeriod: string | null = null
    from: Date | null = null
    to: Date | null = null
    showDatePicker: boolean = false
    showFilter: boolean = false
    //listHeight: string = `${80}vh`
    listHeight: any = 800

    listTypeFilter: any = {
        type: "list",
        value: "mine",
    }


    items = [
        { text: this.$t("history_today"), value: TimePeriod.TODAY },
        { text: this.$t("history_thisWeek"), value: TimePeriod.THIS_WEEK },
        { text: this.$t("history_lastWeek"), value: TimePeriod.LAST_WEEK },
        { text: this.$t("history_thisMonth"), value: TimePeriod.THIS_MONTH },
        { text: this.$t("history_lastMonth"), value: TimePeriod.LAST_MONTH },
        { text: this.$t("history_customTimePeriod"), value: TimePeriod.CUSTOM },
    ]

    mounted() {
        if (sessionStorage) {
            var stored: any = sessionStorage.getItem("historyView")
            if (stored) {
                stored = JSON.parse(stored)
                if (stored.from) this.from = new Date(stored.from)
                if (stored.to) this.to = new Date(stored.to)
                if (stored.selectedTimePeriod) this.selectedTimePeriod = stored.selectedTimePeriod
                if (stored.selectedDateRange) this.selectedDateRange = stored.selectedDateRange
                if (stored.listTypeFilter) this.listTypeFilter = stored.listTypeFilter
            } else this.selectedTimePeriod = TimePeriod.THIS_WEEK
        } else this.selectedTimePeriod = TimePeriod.THIS_WEEK

        if ("historyScrollTop" in sessionStorage) {
            setTimeout(() => {
                const itemsList = this.$el.querySelector(".items-list")
                const scrollTop = parseInt(sessionStorage.getItem("historyScrollTop") || "häst")
                if (itemsList && isFinite(scrollTop)) itemsList.scrollTop = scrollTop
            }, 0)
        }
    }

    onSelectTime(item:any){
        if (item.value == "custom"){
            setTimeout(() => {
                this.showDatePicker = true
            }, 0);
        }
    }

    @Watch("selectedTimePeriod")
    onSelectedTimePeriodChange() {
        if (this.selectedTimePeriod == TimePeriod.CUSTOM) {
            if (this.selectedDateRange.length == 0) {
                this.from = null
                this.to = null
            }
            return
        }

        var from: Date | null = null
        var to: Date | null = null

        switch (this.selectedTimePeriod) {
            case TimePeriod.TODAY:
                from = moment().startOf("day").toDate()
                to = moment().endOf("day").toDate()
                break
            case TimePeriod.THIS_WEEK:
                from = moment().startOf("week").day(moment().day() === 0 ? -6 : 1).toDate()
                to = moment().endOf("day").toDate()
                break
            case TimePeriod.LAST_WEEK:
                from = moment().subtract(1, "weeks").startOf("week").day(moment().day() === 0 ? -6 : 1).toDate()
                to = moment(from).add(1, "weeks").toDate()
                break
            case TimePeriod.THIS_MONTH:
                from = moment().startOf("month").toDate()
                to = moment().endOf("day").toDate()
                break
            case TimePeriod.LAST_MONTH:
                from = moment().subtract(1, "months").startOf("month").toDate()
                to = moment().subtract(1, "months").endOf("month").toDate()
                break
        }
        this.from = from
        this.to = to
        this.resize()
        this.updateSessionStorage()
    }

    getText(item: any){
        if (item.value == "custom" && this.from && this.to) {
            let toText = new Date(this.to)
            toText.setDate(toText.getDate() - 1)
            return this.from.toLocaleDateString('sv-SE') + " - " + toText.toLocaleDateString('sv-SE')
        }
        return item.text
    }

    resize() {
        var height =  window.innerHeight - 210
        this.listHeight = height
    }

    selectedDateRange: string[] = []
    get dateRangeText() {
        return this.selectedDateRange && this.selectedDateRange.length == 2
            ? this.selectedDateRange.sort().join(" - ")
            : ""
    }

    allowedDates(val: string) {
        var today: Date | number = new Date()
        today.setHours(0, 0, 0, 0)
        today = today.getTime()

        var date: Date | number = new Date(val)
        date.setHours(0, 0, 0, 0)
        date = date.getTime()
        return date <= today
    }

    saveDatePicker() {
        if (this.selectedDateRange.length < 2) {
            this.selectedDateRange = []
            this.from = null
            this.to = null
        } else {
            this.selectedDateRange.sort()
            this.from = new Date(this.selectedDateRange[0])
            this.from.setHours(0, 0, 0, 0)
            this.to = new Date(this.selectedDateRange[1])
            this.to.setHours(0, 0, 0, 0)
            this.to.setDate(this.to.getDate() + 1)
        }
        this.updateSessionStorage()
        this.showDatePicker = false
    }


    changeUserFilter(filter: any) {
        this.listTypeFilter = filter
        if (sessionStorage) {
            var stored: any = {}
            if ('historyView' in sessionStorage)
                stored = JSON.parse(sessionStorage['historyView'])
            stored['listTypeFilter'] = this.listTypeFilter
            sessionStorage['historyView'] = JSON.stringify(stored)
        }
        this.refresh()
    }

    updateSessionStorage() {
        if (!sessionStorage) return
        if (!this.from || !this.to) return
        var store: any = {
            from: this.from.getTime(),
            to: this.to.getTime(),
            selectedTimePeriod: this.selectedTimePeriod,
            listTypeFilter: this.listTypeFilter,
        }
        if (this.selectedDateRange) store.selectedDateRange = this.selectedDateRange
        sessionStorage.setItem("historyView", JSON.stringify(store))
    }

    refresh() {
        console.log("refresh history view")
        if (this.myWorkHistoryList.refresh) this.myWorkHistoryList.refresh()
    }

    get myWorkHistoryList() {
        return this.$refs.myWorkHistoryList as Vue & { refresh: () => boolean }
    }
}

export enum TimePeriod {
    TODAY = "today",
    THIS_WEEK = "thisWeek",
    LAST_WEEK = "lastWeek",
    THIS_MONTH = "thisMonth",
    LAST_MONTH = "lastMonth",
    CUSTOM = "custom",
}
